{#if config.show_visual_card}
  <section class="{config.id}-card-wrapper"></section>
{/if}

<section class="wc-payment-form-fields" on:input={formChanged}>
  <p class="form-row form-row-wide">
    <label for="{config.id}-name">Nome do Titular do Cartão <span class="required">*</span></label>
    <input id="{config.id}-name" class="input-text" type="text" bind:value="{$cardForm.name}" readonly={loading} maxlength="25" use:dontCopy>
  </p>

  <p class="form-row form-row-wide">
    <label for="{config.id}-number">Número do Cartão <span class="required">*</span></label>
    <input id="{config.id}-number" class="input-text {!config.show_visual_card && 'wc-credit-card-form-card-number'}" inputmode="numeric" autocomplete="cc-number" type="tel" bind:value="{$cardForm.number}" readonly={loading} use:dontCopy>
  </p>

  <p class="form-row form-row-first">
    <label for="{config.id}-expiry">Validade <span class="required">*</span></label>
    <input id="{config.id}-expiry" class="input-text {!config.show_visual_card && 'wc-credit-card-form-card-expiry'}" inputmode="numeric" autocomplete="cc-exp" type="tel" bind:value="{$cardForm.expiry}" placeholder="MM / AAAA" readonly={loading} use:dontCopy>
  </p>

  <p class="form-row form-row-last">
    <label for="{config.id}-cvc">Código de Segurança <span class="required">*</span></label>
    <input id="{config.id}-cvc" name="{config.id}-cvc" class="input-text {!config.show_visual_card && 'wc-credit-card-form-card-cvc'}" inputmode="numeric" type="tel" maxlength="4" placeholder="CVC" bind:value="{$cardForm.cvc}" readonly={loading} use:dontCopy>
  </p>

  {#if Object.keys($installments).length > 0}
    <p class="form-row form-row-wide">
      <label for="{config.id}-installments">Número de parcelas</label>
      <select id="{config.id}-installments" name="{config.id}-installments" class="input-select">
        {#each Object.keys($installments) as i}
          <option value="{i}">
            {$installments[i]}
          </option>
        {/each}
      </select>
    </p>
  {:else}
    <input type="hidden" name="{config.id}-installments" value="1">
  {/if}

  <input type="hidden" name="{config.id}-checkout-mode" value="form">
  <input type="hidden" id="{config.id}-card-hash" name="{config.id}-card-hash" bind:value={$cardHash}>
  <input type="hidden" id="{config.id}-card-info" name="{config.id}-card-info" bind:value={cardId}>

  {#if error}
    <p class="form-row form-row-wide woocommerce-error">
      {error}
    </p>
  {/if}

  {#if config.user_id != 0 && config.store_user_cards}
    <p class="form-row form-row-wide save-card">
        <label for="{config.id}-save-card">
          <input type="checkbox" id="{config.id}-save-card" name="{config.id}-save-card" value="yes" bind:checked="{$cardForm.save}">
          Salvar este cartão para usar em futuras compras
        </label>
    </p>
  {/if}

  {#if config.credit_cards.length > 0}
    <p class="form-row form-row-wide cancel">
        <button type="button" class="button button-cancel-card" on:click={cancel}>Cancelar</button>
    </p>
  {/if}

</section>

<script>
  export let config;

  import { installments, waitingCardValidation, cardHash, cardForm } from './stores.js';
  import { dontCopy } from './actions.js';
  import { createEventDispatcher } from 'svelte';
  import { onMount, onDestroy } from 'svelte';
  import { initCard } from '../utils/card.js';
  import { createCardHash } from '../utils/juno-checkout.js';
  import { getCheckoutTotal } from '../utils/get-checkout-total.js';
  import { formatNumber } from '../utils/format-number.js';

  const dispatch = createEventDispatcher();
  let atts = {
    cardNumber: {}
  };

  let title = 'Informe os Dados do Cartão de Crédito';
  let error = '';
  let cardId = ''; // card informations

  if (!config.show_visual_card) {
    atts.cardNumber.maxlength = 16;
  }

  function formChanged () {
    $cardHash = '';
  }

  function cancel () {
    dispatch('cancel');
  }

  function getCardBrand (number) {
    const card = new window.Juno.Card();
    const brand = card.getType(number);
    return card ? brand.name : '';
  }

  $: if ($cardForm.number) {
    let brand = getCardBrand($cardForm.number)

    cardId = brand + '--' + $cardForm.number.replace(/[^0-9]/g, '').slice(-4)
  }

  $: loading = $waitingCardValidation;

  $: if ($waitingCardValidation) {
      const request = createCardHash({
        publicToken: config.public_token,
        sandbox: config.sandbox,

        name: $cardForm.name,
        number: $cardForm.number.replace(/[^0-9]/g, ''),
        cvc: $cardForm.cvc,
        expirationMonth: ($cardForm.expiry.split('/')[0] + '').trim(),
        expirationYear: ($cardForm.expiry.split('/')[1] + '').trim(),
      })

      request.then((hash) => $cardHash = hash);

      request.catch((message) => {
        error = message
        $cardHash = 'error'
      });

      request.finally(() => {
        $waitingCardValidation = false
      });
  }

  // init the visual card
  onMount(function () {
    cardForm.reset();

    if (!config.show_visual_card) return;

    initCard({
      debug: true,
      form: config.form,
      container: '.' + config.id + '-card-wrapper',
      formSelectors: {
        nameInput: 'input#' + config.id + '-name',
        numberInput: 'input#' + config.id + '-number',
        expiryInput: 'input#' + config.id + '-expiry',
        cvcInput: 'input#' + config.id + '-cvc',
      },
      //width: 350,
      //formatting: true
      messages: {
        validDate: 'Data Válida', // optional - default 'valid\nthru'
        monthYear: 'Mês/Ano', // optional - default 'month/year'
      },
      placeholders: {
        number: '•••• •••• •••• ••••',
        name: 'Nome',
        expiry: 'MM / AAAA',
        cvc: '•••'
      },
    })
  });
</script>

<style>
  .juno-credit-card-card-wrapper {
    width: 100%;
    max-width: 100%;
    margin-bottom: 32px;
  }

  .woocommerce-error {
    padding: 1em;
  }
</style>
